import { z } from 'zod'
import { optionalString, requiredString } from '../../primitives/string'

/**
 * Empresa (compañía dueña de sociedades y agencias) — fuente única de verdad
 * para la validación del API (nestjs-zod `createZodDto`) y del formulario web
 * (RHF + zodResolver).
 *
 * `name` es único GLOBAL. `type` es de SISTEMA (IDC/CVN) y no forma parte del
 * contrato de escritura: nace IDC y solo la fila CVN histórica lo difiere.
 * Reglas de dominio en el service: una sola `default` (marcar una desmarca la
 * anterior y fuerza `active`), y no se eliminan bloqueadas, CVN ni la default.
 */

export const COMPANY_TYPE = {
  IDC: 'IDC',
  CVN: 'CVN'
} as const
export type CompanyType = (typeof COMPANY_TYPE)[keyof typeof COMPANY_TYPE]

const CompanyInputBaseSchema = z.object({
  name: requiredString()
    .transform((value) => value.trim())
    .pipe(requiredString()),
  /** Número GIIN (FATCA) — opcional; el wire legacy usa '' como vacío. */
  giinNumber: optionalString(),
  default: z.boolean().optional(),
  active: z.boolean().optional()
})

export const CreateCompanyInputSchema = CompanyInputBaseSchema

export const UpdateCompanyInputSchema = CompanyInputBaseSchema.partial()

export type CreateCompanyInput = z.infer<typeof CreateCompanyInputSchema>
export type UpdateCompanyInput = z.infer<typeof UpdateCompanyInputSchema>
